/* Uberflip GWL OB-9563 start here */
module.exports = {
    generateHeaderMenuLinks(arr) {
        return arr.map((link) => `<a href="${link.href}">${link.label}</a>`).join('');
    },


    createElem(elemType, elemOptions, elemText) {
        const newElement = document.createElement(elemType);
        if (elemOptions !== undefined) {
            Object.keys(elemOptions).forEach((attr) => {
                newElement.setAttribute(attr, elemOptions[attr]);
            });
        }
        if (elemText !== undefined) {
            newElement.innerText = elemText;
        }
        return newElement;
    },
};
/* Uberflip GWL OB-9563 end here */


// WEBPACK FOOTER //
// ./script-partials/helperFunctions.js